import { useMemo } from 'react';

import { markdownToHtmlSync } from '@/util/markdown';

export const useMarkdownToHtml = (markdownText: string) => {
  return useMemo(() => {
    try {
      return { html: markdownToHtmlSync(markdownText), error: null as Error | null };
    } catch (err) {
      console.error('Error converting markdown to HTML:', err);
      return { html: '', error: err as Error };
    }
  }, [markdownText]);
};
